module.exports = __webpack_public_path__ + "img/green_bg.c4d6130d.png";